/**
 * Marketplace service for Microsoft Marketplace subscription activation
 */

import { httpWithAuth } from './apiClient';

interface ActivateResponse {
  success: boolean;
  plan_id?: string;
  error?: string;
}

/**
 * Activate a Microsoft Marketplace subscription
 *
 * @param token - The marketplace token from the redirect URL
 * @returns Activation result with plan_id on success
 */
export async function activateMarketplaceSubscription(
  token: string
): Promise<{ success: boolean; plan_id?: string; error?: string }> {
  try {
    const data = await httpWithAuth<ActivateResponse>(
      '/api/marketplace/activate',
      {
        method: 'POST',
        body: JSON.stringify({ marketplace_token: token }),
      }
    );
    return data;
  } catch (error) {
    console.error('Error activating marketplace subscription:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to activate subscription',
    };
  }
}
